import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable, Subject } from "rxjs";
import { tap } from "rxjs/operators";
import _ from "lodash";
import * as moment from "moment";
import { ModalService } from "../index/modal.service";
import {MenuService} from "@root/layout/nav/menu.service";

interface IAssistantList {
  page?: number;
  page_size?: number;
}
interface IHttpResponse {
  error_code: number;
  error_msg: string;
  data: any;
}

export interface IUnread {
  broadcast?: number;
  assistant?: number;
  loseConnect?: number;
  inquiry?: number;
}

export interface ITujia {
  tujia_store_available?: boolean;
  tujia_store_status?: boolean;
  bank_account_status?: boolean;
  tujia_contract_status?: boolean;
}

export interface IShop {
  shop_store_status?: boolean;
  bank_account_status?: boolean;
  shop_contract_status?: boolean;
}

export interface IEnv {
  product: boolean;
}

export interface IZhenguo {
  zhenguoPublish: boolean;
}

export interface IThirdpartyAccount {
  has_thirdparty_account: boolean;
}

export interface IAskAddAccount {
  ask_add_account: boolean;
}

export interface IAskReadHouse {
  ask_read_house: boolean;
}

export interface IFinishBasicInfo {
  basicInfoFinish: boolean;
}

export interface ISubAccount {
  isSubAccount: boolean;
  askInviteData?: any;
}
export interface INotification {
  type: "create" | "delete";
  data?: any;
}
export interface IOauthUrl {
  airbnb: string;
  xiaozhu: string;
  zhenguo: string;
}

export interface IPartnerOperatorInfo {
  is_partner_operator: number;
}

type CustomerServiceStatus = 0 | 1 | null;

// const BROADCAST_ROLLBAR_API = "/api/broadcast/roll_bar";
// const BROADCAST_CLOSE_API = "/api/broadcast/close";
// const BROADCAST_LIST_API = "/api/broadcast/list";
const ASSISTANT_LIST_API = "/api/house_assistant/list";
const ASSISTANT_READ_API = "/api/house_assistant/read";
const CONFIG_INFO_API = "/api/config/init";
const ACCEPT_INVITE_API = "/api/config/accept";
const REFUSE_INVITE_API = "/api/config/refuse";

// const AIRBNB_MODEL_EVENT_API = "/api/activity/event/show_airbnb_model";
const CUSTOMER_SERVICE_STATUS_API = '/api/customer_service/chat/status';
const UPDATE_CUSTOMER_SERVICE_STATUS_API = '/api/customer_service/chat/update_status';

const SYSTEM_NOTIFICATION_API = '/api/pop_window/summary';
@Injectable({
  providedIn: 'root'
})
export class SystemService {
  /** 环境 */
  env: IEnv = {
    product: true
  };

  oauthUrl: IOauthUrl = {
    airbnb: "",
    xiaozhu: "",
    zhenguo: ""
  };

  /** 未读数量 */
  dotCount: IUnread = {
    broadcast: 0,
    assistant: 0,
    loseConnect: 0,
    inquiry: 0
  };
  /** 途家信息的完善程度 */
  tujiaStatus: ITujia = {
    tujia_store_available: false,
    tujia_store_status: false,
    bank_account_status: false,
    tujia_contract_status: false
  };
  /** 微店信息的完善程度 */
  shopStatus: IShop = {
    shop_store_status: false,
    bank_account_status: false,
    shop_contract_status: false
  };

  /** 子账号相关 */
  subAccountInfo: ISubAccount = {
    isSubAccount: false,
    askInviteData: null
  };

  /** 榛果活动是否开启 */
  zhenguoStart: IZhenguo = {
    zhenguoPublish: false
  };

  /** 渠道账号是否添加 */
  thirdpartyAccount: IThirdpartyAccount = {
    has_thirdparty_account: false
  };

  /** 是否询问添加渠道账号  */
  askAddAccount: IAskAddAccount = {
    ask_add_account: false
  };

  /** 是否询问读取房源 */
  askReadHouse: IAskReadHouse = {
    ask_read_house: false
  };

  /** 基本信息是否已经填过 */
  // fininshBasicInfo: IFinishBasicInfo = {
  //   basicInfoFinish: false
  // };

  /** 是否是OpenAPI用户 */
  partnerOperatorInfo: IPartnerOperatorInfo = {
    is_partner_operator: 0
  };

  // operatorInfo = {
  //   logo: "/assets/icon/logo_default.png",
  //   name: ""
  // };

  customerServiceStatus: CustomerServiceStatus = null;
  customerServiceUnreadCount = 0;
  customerServiceClientUreadCount = 0;
  permissionBlacklist = [];

  international = false;

  dotCountRaw$ = new Subject<IUnread>();
  tujiaRaw$ = new Subject<ITujia>();
  shopRaw$ = new Subject<IShop>();
  environmentRaw$ = new Subject<IEnv>();
  oauthUrlRaw$ = new Subject<IOauthUrl>();
  permissionRaw$ = new Subject<Array<any>>();
  notificationRaw$ = new Subject<any>();
  zhenguoRaw$ = new Subject<IZhenguo>();
  hasThirdpartyAccountRaw$ = new Subject<IThirdpartyAccount>();
  askAddAccountRaw$ = new Subject<IAskAddAccount>();
  askReadHouseRaw$ = new Subject<IAskReadHouse>();
  // finishBasicInfo$ = new Subject<IFinishBasicInfo>();
  // operatorInfoRaw$ = new Subject<any>();
  partnerOperatorInfoRaw$ = new Subject<any>();
  customerServiceInfoRaw$ = new Subject<{ status: CustomerServiceStatus, count: number, clientCount: number }>();
  internationalRaw$ = new Subject<boolean>();

  receiveInvitationRaw$ = new Subject();

  // private unreadChange$ = this.unreadRaw$.pipe(
  //   tap(value => (this.dotCount = value))
  // );

  private tujiaChange$ = this.tujiaRaw$.pipe(
    tap(value => (this.tujiaStatus = value))
  );

  private shopChange$ = this.shopRaw$.pipe(
    tap(value => (this.shopStatus = value))
  );

  private zhenguoChange$ = this.zhenguoRaw$.pipe(
    tap(value => (this.zhenguoStart = value))
  );

  private hasThirdpartyAccountChange$ = this.hasThirdpartyAccountRaw$.pipe(
    tap(value => (this.thirdpartyAccount = value))
  );

  private askAddAccountChange$ = this.askAddAccountRaw$.pipe(
    tap(value => (this.askAddAccount = value))
  );

  private askReadHouseChange$ = this.askReadHouseRaw$.pipe(
    tap(value => (this.askReadHouse = value))
  );

  // private finishBasicInfoChange$ = this.finishBasicInfo$.pipe(
  //   tap(value => (this.fininshBasicInfo = value))
  // );

  private environmentChange$ = this.environmentRaw$.pipe(
    tap(value => (this.env = value))
  );
  private oauthUrlChange$ = this.oauthUrlRaw$.pipe(
    tap(value => (this.oauthUrl = value))
  );

  private permissionChange$ = this.permissionRaw$.pipe(
    tap(value => (this.permissionBlacklist = value))
  );

  // private operatorInfoChange$ = this.operatorInfoRaw$.pipe(
  //   tap(value => (this.operatorInfo = value))
  // );

  private partnerOperatorInfoChange$ = this.partnerOperatorInfoRaw$.pipe(
    tap(value => (this.partnerOperatorInfo = value))
  );
  private customerServiceInfoChange$ = this.customerServiceInfoRaw$.pipe(
    tap(value => {
      this.customerServiceStatus = value.status;
      this.customerServiceUnreadCount = value.count;
      this.customerServiceClientUreadCount = value.clientCount;
    })
  );

  private internationalChange$ = this.internationalRaw$.pipe(tap(v => this.international = v));
  constructor(
    private http: HttpClient,
    private menuSrv: MenuService
    ) {
    // this.unreadChange$.subscribe();
    this.tujiaChange$.subscribe();
    this.shopChange$.subscribe();
    this.zhenguoChange$.subscribe();
    this.oauthUrlChange$.subscribe();
    this.hasThirdpartyAccountChange$.subscribe();
    this.askAddAccountChange$.subscribe();
    this.askReadHouseChange$.subscribe();
    // this.finishBasicInfoChange$.subscribe();
    this.environmentChange$.subscribe();
    this.oauthUrlChange$.subscribe();
    this.permissionChange$.subscribe();
    // this.operatorInfoChange$.subscribe();
    this.partnerOperatorInfoChange$.subscribe();
    this.customerServiceInfoChange$.subscribe();
    this.internationalChange$.subscribe();
  }

  updateDotCount(count: IUnread) {
    this.dotCount = count;
    this.dotCountRaw$.next(count);
  }

  updateTujiaStatus(status: ITujia) {
    this.tujiaRaw$.next(status);
  }

  updateShopStatus(status: IShop) {
    this.shopRaw$.next(status);
  }

  updateZhenguoPublish(status: IZhenguo) {
    this.zhenguoRaw$.next(status);
  }

  updateHasThirdpartyAccount(status: IThirdpartyAccount) {
    this.hasThirdpartyAccountRaw$.next(status);
  }

  updateAskAddAccount(status: IAskAddAccount) {
    this.askAddAccountRaw$.next(status);
  }

  updateAskReadHouse(status: IAskReadHouse) {
    this.askReadHouseRaw$.next(status);
  }

  // updateFinishBasicInfo(status: IFinishBasicInfo) {
  //   this.finishBasicInfo$.next(status);
  // }

  updateEnvironment(env: IEnv) {
    this.environmentRaw$.next(env);
  }
  updateOauthUrl(url: IOauthUrl) {
    this.oauthUrlRaw$.next(url);
  }

  updatePermissionBlacklist(list: Array<any>) {
    this.permissionRaw$.next(list);
  }

  updateNotification(notification: any) {
    this.notificationRaw$.next(notification);
  }

  // updateOperatorInfo(info) {
  //   this.operatorInfoRaw$.next(info);
  // }

  updatePartnerOperatorInfo(status: IPartnerOperatorInfo) {
    this.partnerOperatorInfoRaw$.next(status);
  }

  updateCustomerServiceInfo(info) {
    this.customerServiceInfoRaw$.next(info);
  }

  updateInternational(international) {
    this.internationalRaw$.next(international);
  }

  // /** 系统通知横幅 */
  // getBroadcastRollbar() {
  //   return this.http.get(BROADCAST_ROLLBAR_API) as Observable<IHttpResponse>;
  // }

  // /** 关闭通知横幅 */
  // broadcastClose() {
  //   return this.http.post(BROADCAST_CLOSE_API, null) as Observable<
  //     IHttpResponse
  //   >;
  // }

  // /** 获取系统消息列表 */
  // getBroadcastList() {
  //   return this.http.get(BROADCAST_LIST_API) as Observable<IHttpResponse>;
  // }

  /** 获取房态助手列表 */
  getAssistantList(params: IAssistantList) {
    const query = new HttpParams()
      .append("page", `${params.page}`)
      .append("page_size", `${params.page_size}`);
    return this.http.get(ASSISTANT_LIST_API, { params: query }) as Observable<
      IHttpResponse
    >;
  }

  /** 设置消息列表为已读状态 */
  setAssistantRead() {
    return this.http.get(ASSISTANT_READ_API) as Observable<IHttpResponse>;
  }

  /** 获取所有的初始化消息数量 */
  getConfigInfo() {
    return this.http.get(CONFIG_INFO_API) as Observable<IHttpResponse>;
  }


  private updateConfitInfo(res) {
    const data = res.data;
    const unread = {
      broadcast: _.get(data, "unread_broadcast_count") || 0,
      assistant: _.get(data, "unread_housing_assistant_count") || 0,
      loseConnect: _.get(data, "lose_connection_count") || 0,
      inquiry: _.get(data, "unread_inquiry_count") || 0
    };

    const tujiaStatus = {
      bank_account_status: !!_.get(data, "bank_account_status"),
      tujia_store_status: !!_.get(data, "tujia_store_status"),
      tujia_store_available: !!_.get(data, "tujia_store_available"),
      tujia_contract_status: !!_.get(data, "tujia_contract_status")
    };

    const shopStatus = {
      bank_account_status: !!_.get(data, "bank_account_status"),
      shop_store_status: !!_.get(data, "shop_store_status"),
      shop_contract_status: !!_.get(data, "shop_shelf_agreement")
    };

    const oauthUrl = _.get(data, "oauth_url");

    const product = !!_.get(data, "is_product");

    const isSubAccount = _.get(data, "is_subaccount");
    const askInviteData = _.get(data, "ask_invite");

    const permissionBlacklist = _.get(data, "permission_blacklist");
    const zhenguoPublish = _.get(data, "zhenguotuiguang");
    const has_thirdparty_account = _.get(data, "has_thirdparty_account");
    const ask_add_account = _.get(data, "ask_add_account");
    const ask_read_house = _.get(data, "ask_read_house");
    const isFinishBasicInfo = _.get(data, "is_finish_basic_info");

    const logo =
      _.get(data, "operator_image.small_url") ||
      "/assets/icon/logo_default.png";
    const name = _.get(data, "operator_name");

    const is_partner_operator = _.get(data, 'is_partner_operator') || 0;

    const international = _.get(data, 'is_global');

    this.updateDotCount(unread);
    this.updateTujiaStatus(tujiaStatus);
    this.updateShopStatus(shopStatus);
    this.updateZhenguoPublish(zhenguoPublish);
    this.updateOauthUrl(oauthUrl);
    this.updateHasThirdpartyAccount(has_thirdparty_account);
    this.updateAskAddAccount(ask_add_account);
    this.updateAskReadHouse(ask_read_house);
    // this.updateFinishBasicInfo(isFinishBasicInfo);
    this.updateEnvironment({ product });
    this.updateOauthUrl(oauthUrl);
    this.updatePermissionBlacklist(permissionBlacklist);
    // this.updateOperatorInfo({ logo, name });
    this.updatePartnerOperatorInfo(is_partner_operator);
    this.updateInternational(international);

    this.receiveInvitationRaw$.next(askInviteData);
  }

  initMsgCount() {
    this.getConfigInfo().subscribe(res => {
      const data = res.data;
      this.dotCount.broadcast = data.unread_broadcast_count;
      this.dotCount.assistant = data.unread_housing_assistant_count;
      this.dotCount.loseConnect = data.lose_connection_count;
      this.dotCount.inquiry = data.unread_inquiry_count;
    });
  }

  syncFetchConfigInfo() {
    return this.getConfigInfo().pipe(tap(value => this.updateConfitInfo(value)));
  }
  fetchConfigInfo() {

    this.getConfigInfo().pipe(tap(value => this.updateConfitInfo(value))).subscribe();
  }

  /**
   * 系统通知
   * 显示在页面的头部，用于临时通知用户一些信息
   * 目前似乎已经不再使用
   */
  fetchNotification() {
    this.http.get(SYSTEM_NOTIFICATION_API).subscribe(res => {
      const data = _.get(res, 'data.pop_window');
      if (data) {
        this.updateNotification(data);
      }
    });
    // this.getBroadcastRollbar().subscribe(res => {
    //   const data = res.data && res.data.roll_bar;
    //   if (data && moment().isBefore(data.expire_time)) {
    //     this.updateNotification({ type: "create", data: data });
    //   }
    // });
  }

  // removeNotification() {
  //   this.broadcastClose().subscribe(() =>
  //     this.updateNotification({ type: "delete" })
  //   );
  // }

  fetchCustomerServiceInfo() {
    this.http.get(CUSTOMER_SERVICE_STATUS_API).subscribe(res => {
      const status = _.get(res, 'data.customer_service.status');
      const count = _.get(res, 'data.customer_service.unread_count');
      const clientCount = _.get(res, 'data.unread_count');
      this.updateCustomerServiceInfo({ status, count, clientCount });
    });
  }

  requestUpdateCustomerServiceStatus() {
    this.http.post(UPDATE_CUSTOMER_SERVICE_STATUS_API, null).subscribe();
  }

  acceptInvite() {
    return this.http.post(ACCEPT_INVITE_API, null) as Observable<IHttpResponse>;
  }

  refuseInvite() {
    return this.http.post(REFUSE_INVITE_API, null) as Observable<IHttpResponse>;
  }
}
